import { DragDropContext } from "react-dnd-legacy"
import HTML5Backend from "react-dnd-html5-backend-legacy"

export default DragDropContext(HTML5Backend)
